export default "__VITE_ASSET__DaOTYojl__"